import { Section } from '../../MyAccount/Profile/styles';
import Typography from '../../../kingpin/atoms/Typography';
import Inputs from '../../Inputs';
import React from 'react';
import styled from 'styled-components';

const Positioner = styled.div`
  background-color: var(--color-bg-muted);
  padding: 12px;
  margin-bottom: 8px;
`;

const YAxisControls = ({
  minY,
  maxY,
  minYBehaviour,
  maxYBehaviour,
  setMinY,
  setMaxY,
  setMinYBehaviour,
  setMaxYBehaviour,
}: {
  minY: number | undefined;
  maxY: number | undefined;
  minYBehaviour: 'auto' | 'set' | undefined;
  maxYBehaviour: 'auto' | 'set' | undefined;
  setMinY: (minY: number | undefined) => void;
  setMaxY: (maxY: number | undefined) => void;
  setMinYBehaviour: (minYBehaviour: 'auto' | 'set') => void;
  setMaxYBehaviour: (maxYBehaviour: 'auto' | 'set') => void;
}) => (
  <Positioner>
    <Section>
      <Typography.Body type="Label">Min Y Behaviour</Typography.Body>
      <Inputs.Dropdown
        placeholder={'Min Y Behaviour'}
        selectedLabel={minYBehaviour}
        testId={'min-y-behaviour-dropdown'}
        options={[
          {
            label: 'Auto',
            value: 'auto',
            onSelected: () => setMinYBehaviour('auto'),
          },
          {
            label: 'Set',
            value: 'set',
            onSelected: () => setMinYBehaviour('set'),
          },
        ]}
      />
    </Section>
    {minYBehaviour === 'set' && (
      <Section>
        <Typography.Body type="Label">Min Y</Typography.Body>
        <Inputs.TextInput
          placeholder={'Min Y'}
          data-testid={'group-vs-remainder-min-y-input'}
          value={minY?.toString() || '0'}
          onChange={(e) => setMinY(parseInt(e.target.value))}
        />
      </Section>
    )}

    <Section>
      <Typography.Body type="Label">Max Y Behaviour</Typography.Body>
      <Inputs.Dropdown
        placeholder={'Max Y Behaviour'}
        selectedLabel={maxYBehaviour}
        testId={'max-y-behaviour-dropdown'}
        options={[
          {
            label: 'Auto',
            value: 'auto',
            onSelected: () => setMaxYBehaviour('auto'),
          },
          {
            label: 'Set',
            value: 'set',
            onSelected: () => setMaxYBehaviour('set'),
          },
        ]}
      />
    </Section>
    {maxYBehaviour === 'set' && (
      <Section>
        <Typography.Body type="Label">Max Y</Typography.Body>
        <Inputs.TextInput
          placeholder={'Max Y'}
          data-testid={'group-vs-remainder-max-y-input'}
          value={maxY?.toString() || '0'}
          onChange={(e) => setMaxY(parseInt(e.target.value))}
        />
      </Section>
    )}
  </Positioner>
);

export default YAxisControls;
